// 歌曲列表相关

export default [
  {
    path: '/thunder/top/:type',
    name: 'top',
    component: () => import('@/views/song_list/top.vue'),
    meta: {
      title: '排行榜',
    },
  },
  {
    path: '/thunder/topsHome',
    name: 'topsHome',
    redirect: '/thunder/home/topsHome',
  },
  {
    path: '/thunder/topsSong',
    name: 'topsSong',
    component: () => import('@/views/song_list/tops_song.vue'),
    meta: {
      title: '排行榜',
    },
  },
  {
    path: '/thunder/topsSongLR',
    name: 'topsSongLR',
    component: () => import('@/views/song_list/tops_song_lr.vue'),
    meta: {
      title: '排行榜',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/allTop',
    name: 'allTop',
    component: () => import('@/views/song_list/all_top_v2.vue'),
    meta: {
      title: '榜单',
    },
  },
  {
    path: '/thunder/topList',
    name: 'topList',
    component: () => import('@/views/song_list/top_list.vue'),
    meta: {
      title: '榜单',
    },
  },
  {
    path: '/thunder/weekRule',
    name: 'weekRule',
    component: () => import('@/views/song_list/rule.vue'),
    meta: {
      title: '榜单',
    },
  },
  {
    path: '/thunder/choiceTop',
    name: 'choiceTop',
    component: () => import('@/views/song_list/choice_top.vue'),
    meta: {
      title: '精选榜单页',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/recommendTop',
    name: 'recommendTop',
    component: () => import('@/views/song_list/recommend_list.vue'),
    meta: {
      title: '官方推荐',
    },
  },
  {
    path: '/thunder/everySing',
    name: 'everySing',
    component: () => import('@/views/song_list/every_sing.vue'),
    meta: {
      title: '精选榜单页',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/classify_singer',
    name: 'singerList',
    redirect: '/thunder/home/classify_singer',
  },
  {
    path: '/thunder/singer/:singer',
    name: 'singerdetail',
    component: () => import('@/views/song_list/singer.vue'),
    meta: {
      title: '歌手详情',
    },
  },
  {
    path: '/thunder/search',
    name: 'searchSongs',
    component: () => import('@/views/song_list/search_songs.vue'),
    meta: {
      title: '歌曲搜索',
    },
    // 从语音控制跳转传参
    props: (route) => ({
      query: route.query.q,
    }),
  },
  {
    path: '/thunder/ordered',
    name: 'orderedSong',
    // component: () => import('@/views/song_list/ordered_song.vue'),
    component: () => import('@/views/song_list/ordered_song_v2.vue'),
    meta: {
      title: '已点歌曲',
    },
  },
  {
    path: '/thunder/like',
    name: 'likeSong',
    component: () => import('@/views/private_muisc/personal_Songs.vue'),
    meta: {
      title: '私人曲库',
      notShowOrderList: true, // 去掉滚动消息
    },
  },
  {
    path: '/thunder/tabManage',
    name: 'tabManage',
    component: () => import('@/views/private_muisc/tab_manage.vue'),
    meta: {
      title: '歌单管理',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/hometown',
    name: 'hometown',
    component: () => import('@/views/song_list/hometown.vue'),
    meta: {
      title: '乡音',
    },
  },
  {
    path: '/thunder/hometown_song',
    name: 'hometownSong',
    component: () => import('@/views/song_list/hometown_song.vue'),
    meta: {
      title: '乡音歌曲列表',
    },
  },
  {
    path: '/thunder/guess_like',
    name: 'guessLike',
    component: () => import('@/views/song_list/like.vue'),
    meta: {
      title: '猜你喜欢',
    },
  },
  {
    path: '/thunder/song_words_play',
    name: 'songWordsPlay',
    component: () => import('@/views/song_list/song_words_play.vue'),
    meta: {
      title: '歌词游戏',
    },
  },
  {
    path: '/thunder/private_search/:listid',
    name: 'privateSearch',
    component: () => import('@/views/private_muisc/search_private.vue'),
    meta: {
      title: '添加歌曲',
    },
  },
  {
    path: '/thunder/maiba_list',
    name: 'maiba',
    component: () => import('@/views/song_list/maiba.vue'),
    meta: {
      title: '手机点歌',
    },
  },
  {
    path: '/thunder/toprank',
    name: '榜单歌单',
    component: () => import('@/views/song_list/toprank.vue'),
    meta: {
      title: '手机点歌',
    },
  },
  {
    path: '/thunder/high_song',
    name: 'high_song',
    component: () => import('@/views/song_list/high_song.vue'),
    meta: {
      title: '高分作品',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/electronic_music_party',
    component: () => import('@/views/activity/electronic-music-party/index.vue'),
    name: 'electronic_music_party',
    meta: {
      title: '雷石电音轰趴',
    },
  },
  {
    path: '/thunder/electronic_music_party/selected',
    component: () => import('@/views/activity/electronic-music-party/selected.vue'),
    name: 'electronic_music_party_selected',
    meta: {
      title: '雷石电音轰趴',
    },
  },
  {
    path: '/thunder/electronic_music_party/starting',
    component: () => import('@/views/activity/electronic-music-party/starting.vue'),
    name: 'electronic_music_party_starting',
    meta: {
      title: '雷石电音轰趴',
    },
  },
  {
    path: '/thunder/adopt_godsong',
    name: 'adopt_godsong',
    component: () => import('@/views/song_list/geshen_sing.vue'),
    meta: {
      title: '歌神必唱',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/banzou_vip',
    name: 'banzou_vip',
    component: () => import('@/views/song_list/banzou_vip'),
    meta: {
      title: 'VIP伴奏榜',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/discount',
    name: 'ad',
    component: () => import('@/views/ad/index'),
    meta: {
      title: '雷石特惠页',
      level: 1,
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/translate_songlist',
    name: 'translate_songlist',
    component: () => import('@/views/song_list/translate_songlist'),
    meta: {
      title: '音译歌单页',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/myoften',
    name: 'myoften',
    component: () => import('@/views/song_list/myoftensing'),
    meta: {
      title: '我的常唱页',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/classified_songlist',
    name: 'classified_songlist',
    component: () => import('@/views/song_list/classified_songlist.vue'),
    meta: {
      title: '分类歌单',
      notShowOrderList: true,
      level: 1,
    },
  },
  {
    path: '/thunder/search-feedback',
    name: 'searchFeedback',
    component: () => import('@/views/feedback/search-result'),
    meta: {
      title: '搜索反馈',
      notShowOrderList: true,
    },
  },
]
